import styled from 'styled-components';
import { Chip, Typography } from '@mui/material';

import colors from '../../../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding: 20px;
`;

const TrackCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: ${colors.shades.secondary10};
  border: 1px solid ${colors.shades.secondary7};
  overflow: hidden;
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 14px;
  row-gap: 6px;
`;

const CardFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 14px;
  border-top: 1px solid ${colors.shades.secondary7};
`;

const RemoveAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: ${colors.shades.secondary3};

  &:hover {
    color: ${colors.base.danger};
  }
`;

const MetaRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

const MetaDate = styled(Typography)`
  font-size: 13px;
  color: ${colors.shades.secondary3};
`;

const TrackName = styled(Typography)`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.base.secondary2};
`;

const TrackDetail = styled(Typography)`
  font-size: 14px;
  color: ${colors.shades.secondary3};
`;

const StatusChip = styled(Chip)`
  height: 24px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ status }) => {
    switch (status) {
      case 'ACTIVE': return colors.base.success;
      case 'COMPLETED': return colors.shades.secondary7;
      case 'REMOVED': return colors.shades.danger2;
      default: return colors.shades.secondary7;
    }
  }};
  color: ${({ status }) => {
    switch (status) {
      case 'ACTIVE': return colors.shades.secondary8;
      case 'COMPLETED': return colors.shades.secondary3;
      case 'REMOVED': return colors.shades.danger3;
      default: return colors.shades.secondary3;
    }
  }};
`;

const FilterChip = styled(Chip)`
  font-size: 13px;
  font-weight: 500;
`;

const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 4px;
`;

const RemoveText = styled(Typography)`
  font-size: 13px;
  color: ${colors.shades.secondary3};
  margin-left: 4px;
`;

const EmptyText = styled(Typography)`
  font-size: 14px;
  color: ${colors.shades.secondary3};
  text-align: center;
  padding: 40px 20px;
`;

export {
  Container,
  TrackCard,
  CardBody,
  CardFooter,
  MetaRow,
  MetaDate,
  TrackName,
  TrackDetail,
  StatusChip,
  RemoveAction,
  RemoveText,
  FilterChip,
  FilterContainer,
  EmptyText,
};
